import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppIcon from "../components/AppIcon";
import "../styles/login.css";

const resolveLoginUrl = () => {
  const configuredUrl = (process.env.REACT_APP_API_URL || "").trim();
  if (configuredUrl) {
    return `${configuredUrl.replace(/\/+$/, "")}/auth/login`;
  }
  return "/api/auth/login";
};

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [logoFailed, setLogoFailed] = useState(false);

  const redirectByRole = (role) => {
    if (["admin", "superadmin"].includes(role)) return navigate("/admin/dashboard");
    if (role === "teacher") return navigate("/teacher/dashboard");
    if (role === "parent") return navigate("/parent/dashboard");
    return navigate("/login");
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    const normalizedEmail = String(email || "").trim();
    const normalizedPassword = String(password || "");
    setEmail(normalizedEmail);
    try {
      const response = await fetch(resolveLoginUrl(), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: normalizedEmail, password: normalizedPassword })
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.message || "Invalid credentials");
      }

      localStorage.setItem("token", data.token);
      if (["admin", "superadmin"].includes(data.user.role)) localStorage.setItem("adminToken", data.token);
      if (data.user.role === "teacher") localStorage.setItem("teacherToken", data.token);
      if (data.user.role === "parent") localStorage.setItem("parentToken", data.token);
      localStorage.setItem("role", data.user.role);
      localStorage.setItem("user", JSON.stringify(data.user));
      redirectByRole(data.user.role);
    } catch (err) {
      setError(err.message || "Invalid credentials");
    }
  };

  return (
    <div className="login-shell">
      <main className="login-center-wrap">
        <section className="login-form-card">
          <div className="login-form-heading">
            {!logoFailed ? (
              <img
                src="/school-logo.png"
                alt="School logo"
                className="login-inline-logo"
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <span className="login-inline-logo-fallback">M</span>
            )}
            <h2 className="login-panel-title">Welcome To MPIPS</h2>
          </div>
          <p className="login-panel-subtitle">Enter your credentials to continue.</p>

          <form onSubmit={handleLogin} className="login-form">
            <label htmlFor="common-email" className="login-label">Email</label>
            <input
              id="common-email"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="login-input"
            />

            <label htmlFor="common-password" className="login-label">Password</label>
            <div className="login-password-wrap">
              <input
                id="common-password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="login-password-input"
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="login-eye-btn"
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <AppIcon name={showPassword ? "eyeOff" : "eye"} />
              </button>
            </div>

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="login-submit-btn">Login</button>
          </form>
        </section>
      </main>
    </div>
  );
};

export default Login;
